<div class="terra-form-field-wrapper wrapper" [style.grid-template-columns]="prefixWidth + ' ' + numberWidth">
  <ng-content select="label"></ng-content>

  <mat-form-field appearance="outline" class="prefix-field-wrapper">
    <input
      type="text"
      id="ddlCountryPrefix"
      placeholder="+"
      aria-label="Number"
      matInput
      [formControl]="prefixControl"
      [matAutocomplete]="auto"
      (focus)="prefixControlTouched()"
      (blur)="prefixBlur()"
      role="presentation"
      autocomplete="nope"
      [required]="errorState"
    />
    <mat-autocomplete #autocompleRef #auto="matAutocomplete" autoActiveFirstOption (closed)="prefixClosed()">
      <mat-option *ngFor="let prefix of filteredPrefixes$ | async" [value]="prefix">
        {{ prefix }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" class="phone-field-wrapper">
    <input
      type="tel" matInput id="txtPhone" [formControl]="phoneControl"
      class="lo_sensitive" (focus)="phoneControlTouched()" [required]="errorState"
      [value]="phoneControl.value | phoneNumber" (change)="cleanPhoneString()"/>
  </mat-form-field>
</div>

<ng-container *ngIf="errorState">
  <ng-content select="mat-error"></ng-content>
</ng-container>
